export default __webpack_public_path__ + "static/media/640_dummy2016-massagestudio01-mobile-de.0b1f1a74.png";